import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

import type { GetUsersProjectParams } from '@/services/http/projectService/projectInvite'

type UseGetUsersProjectInviteProps = GetUsersProjectParams & {
  enabled?: boolean
}

export function useGetUsersProjectInvite({
  projectId,
  search,
  enabled = true,
}: UseGetUsersProjectInviteProps) {
  const { toast } = useToast()

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['usersProjectInvite', { projectId, search }],
    queryFn: () =>
      projectService.projectInvite.getUsersProjectInvite({
        projectId,
        search,
      }),
    enabled,
  })

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Erro ao buscar usuários do projeto',
        description: 'Por favor, tente novamente mais tarde',
      })
    }
  }, [isError, toast])

  if (data) {
    return {
      usersProjectInvite: data,
      isLoading,
      isError,
      refetchUsersProjectInvite: refetch,
    }
  }

  return {
    usersProjectInvite: [],
    isLoading,
    isError,
    refetchUsersProjectInvite: refetch,
  }
}
